
/**
 * Shows a payment dialog box that either confirms the payment amount, or
 * gives an error message, executes a payment, then returns.
 */

import React from 'react';
import { connect } from 'react-redux';
import {centsToString, price_string_to_cents} from "../../lib/currency-utils";
import {Action, TextLoading} from "../funcs/utils";
import {Modal} from "../components/modal";
import {DwollaFundingSourceStates} from "../../lib/dwolla/constants";
import {PaymentRequest} from "./actions";


const dispatch_payment = (
  component, contrib_prm, on_payment_done,
  payment_from, payment_to) => () => {

  component.setState({ execute_payment: true });
  const amt_cents = price_string_to_cents(contrib_prm.getValue(component.state));

  PaymentRequest(
    component.props.token, component.props.onboarding_token,
    payment_from.username, payment_from.acct,
    payment_to.username, payment_to.acct,
    amt_cents, null, null, false)
    .then(res => {
      component.setState({
        show_payment_popup: false,
      })
      on_payment_done();
    })
    .catch(err => {
      const error_msg = err.error && err.error.error_msg;
      component.setState({
        show_payment_popup: true,
        payment_dollar_dirty: false,
        execute_payment: false,
        error_msg,
      })
    })
}

const has_funding_source = component => {
  const dwolla = component.props.dwolla['0000'];
  let has_source = false;

  Object.keys(dwolla.funding_source).forEach(id => {
    const source = dwolla.funding_source[id];
    if (source.state === DwollaFundingSourceStates.VERIFIED) {
      has_source = true;
    }
  });
  return has_source;
}

/**
 * payment_from: {
 *   username: string,
 *   index: int,
 *   payment_id: string,
 * }
 * payment_to: {
 *   username: string,
 *   index: int,
 * }
 */
const ExecutePaymentDialog2_ = props => {
  const { component, payment_from, payment_to,
    contrib_prm, on_payment_done } = props;

  if (!component.state.show_payment_popup) {
    return null;
  }

  const on_close = () => {
    component.setState({ show_payment_popup: false });
  };

  const payment_cents = price_string_to_cents(contrib_prm.getValue(component.state));
  const dwolla = props.dwolla['0000'];

  let payload = null;
  let error_msg;

  if (!dwolla) {
    error_msg = "Payment processor is not initialized.";
  } else if (payment_cents === 0) {
    error_msg = "Enter a value greater than zero.";
  } else if (!has_funding_source(component)) {
    error_msg = "Must add a payment source.";
  } else if (component.state.error_msg) {
    error_msg = component.state.error_msg;
  }

  if (error_msg) {
    const div_style = {
      fontSize: "1.5rem",
    }
    payload = (
      <div align={"center"} style={div_style}>
        <span>{error_msg}</span>
        <div style={{height: "3rem"}}/>
        <Action onClick={on_close}>
          Ok
        </Action>
      </div>
    )
  } else {
    const div_style = {
      fontSize: "1.5rem",
      fontWeight: "bold",
    }
    payload = (
      <div align={"center"} style={div_style}>
        <span>{ centsToString(payment_cents) }</span>
        <div style={{height: "3rem"}}/>
        <Action
          onClick={dispatch_payment(
            component,
            contrib_prm,
            on_payment_done,
            payment_from,
            payment_to)}
          disabled={component.state.execute_payment}>
          <TextLoading
            label={"Contribute"}
            loading={component.state.execute_payment}/>
        </Action>
      </div>
    )
  }
  return (
    <Modal
      container_style={{width: "40rem"}}
      show={true}
      onDismiss={on_close}
      onClose={on_close}
      noFooter={true}>
      { payload }
    </Modal>
  );

}

const mapDispatchToProps = dispatch => {
  return {
  };
}

const mapStateToProps = state => {
  return {
    dwolla: state.dwolla,
  };
}

const ExecutePaymentDialog2 = connect(mapStateToProps, mapDispatchToProps)(ExecutePaymentDialog2_);

export { ExecutePaymentDialog2 };
